'use client'

import React from 'react'
import Link from '@/components/Link'
import { TenantFromPrebuildFragment } from '@/generated/graphql'
import { Button, Container, Stack, Typography, AppBar, Toolbar } from '@mui/material'
import { resolveLogoVariant } from '@caterdesk/ui--feedr-logo'
import Image from 'next/image'
import { getTenantLinkComponentRule } from '@/helpers/tenants'

type Props = {
  tenant: TenantFromPrebuildFragment
}

const NotFound: React.FC<Props> = ({ tenant }) => {
  const homepageRule = getTenantLinkComponentRule('/', tenant.domain, true)
  return (
    <>
      <AppBar sx={{ position: 'absolute' }} color="inherit" position="static">
        <Toolbar>
          <div style={{ position: 'relative', height: 50, width: 100 }}>
            <Link href={homepageRule.uri} passHref>
              <Image
                src={resolveLogoVariant({
                  setToRainbowDuringPride: true,
                  logos: tenant.marketing.logos,
                })}
                alt="Logo"
                layout="fill"
                objectFit="contain"
              />
            </Link>
          </div>
        </Toolbar>
      </AppBar>
      <Container
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
          <Image src="/images/broken-bowl.svg" width={257} height={144} alt="" />
          <Typography variant="h3" textAlign="center">
            Oops, this page isn&apos;t here
          </Typography>
          <Typography variant="body1" textAlign="center">
            The page you&apos;re looking for couldn&apos;t be found. It may have moved or been
            deleted.
          </Typography>
          <Stack direction="row" justifyContent="center">
            <Link href={homepageRule.uri} passHref>
              <Button variant="contained">Return to homepage</Button>
            </Link>
          </Stack>
        </Stack>
      </Container>
    </>
  )
}

export default NotFound
